import usePermissions from '../hooks/usePermissions';
import AccessDeniedBox from './AccessDeniedBox';

/**
 * Wrapper de rutas o secciones grandes. Bloquea el render del children si el
 * usuario no tiene el permiso requerido (o si la compañía no tiene el módulo
 * contratado). Por defecto muestra <AccessDeniedBox />.
 *
 * Ventaja sobre el patrón actual de "montar → fetch → 403 → AccessDeniedBox":
 * aquí el componente no se monta y no se dispara ningún fetch.
 *
 * Uso típico en App.js:
 *
 *   <Route
 *     path="/gestion_comercial/prestamos"
 *     element={
 *       <RequirePermission modulo="prestamos" accion="ver" modulo_contratado="prestamos">
 *         <LoansManagement />
 *       </RequirePermission>
 *     }
 *   />
 */
export default function RequirePermission({
  modulo,
  accion = 'ver',
  modulo_contratado,
  fallback,
  children,
}) {
  const { hasPermission, hasModule } = usePermissions();

  if (modulo_contratado && !hasModule(modulo_contratado)) {
    return (
      fallback ?? (
        <AccessDeniedBox
          title="Módulo no contratado"
          message="Este módulo no está disponible en tu plan actual. Contacta a tu administrador para más información."
          hint="Puedes navegar a otras secciones desde el menú lateral o actualizar tu plan desde Configuración."
        />
      )
    );
  }

  if (!hasPermission(modulo, accion)) {
    return fallback ?? <AccessDeniedBox />;
  }

  return children;
}
